import { gql } from 'apollo-angular';

export const confirmDocumentMutation = gql`
  mutation confirmDocument($input: ResidentS3FileInput!) {
    confirmDocument(input: $input)
  }
`;
